import { defineComponent } from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import FormattedPrice from '@/components/Base/Formats/FormattedPrice.vue';
export default defineComponent({
    name: 'shipping-option-selection',
    components: { FormattedPrice },
    methods: Object.assign({ selectShippingOption(shipping_option_id) {
            this.setShippingOption(shipping_option_id);
        } }, mapActions('blue', {
        setShippingOption: 'SET_SHIPPING_OPTION',
    })),
    computed: Object.assign(Object.assign({}, mapGetters('blue', {
        currentShippingOption: 'currentShippingOption',
    })), mapState('blue', ['shipping_options', 'cart'])),
});
